<template>
  <div class="dashboard-editor-container">
    <div class="welcome-header">
      <h1 class="welcome-title">
        {{ $t('dashboard.welcome', { name: displayName }) }}
      </h1>
      <p v-if="userRoleLabel" class="welcome-role">{{ userRoleLabel }}</p>
      <p class="welcome-subtitle">{{ $t('dashboard.welcomeSubtitle') }}</p>
    </div>

    <el-row v-if="quickLinks.length" :gutter="20" class="quick-links">
      <el-col
        v-for="link in quickLinks"
        :key="link.path"
        :xs="24"
        :sm="12"
        :md="8"
      >
        <router-link :to="link.path" class="quick-link-card-wrap">
          <el-card shadow="hover" class="quick-link-card">
            <div class="quick-link-title">{{ link.title }}</div>
            <div class="quick-link-desc">{{ link.description }}</div>
          </el-card>
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardEditor',
  computed: {
    ...mapGetters([
      'name',
      'permissions',
      'isSuperviseurGrade',
      'userRoleLabel',
    ]),
    displayName() {
      return this.name || this.$t('dashboard.defaultUser');
    },
    quickLinks() {
      const links = [];
      if (this.isSuperviseurGrade) {
        links.push({
          path: '/espace-superviseur/dashboard',
          title: this.$t('route.espaceSuperviseur'),
          description: this.$t('dashboard.superviseurHint'),
        });
      }
      return links;
    },
  },
};
</script>

<style scoped>
.dashboard-editor-container {
  min-height: calc(100vh - 120px);
  padding: 32px 24px;
  background: #f5f7fa;
}

.welcome-header {
  max-width: 720px;
  margin-bottom: 32px;
}

.welcome-title {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 600;
  color: #303133;
}

.welcome-role {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  text-transform: capitalize;
}

.welcome-subtitle {
  margin: 0;
  font-size: 15px;
  color: #606266;
  line-height: 1.5;
}

.quick-link-card-wrap {
  display: block;
  text-decoration: none;
  margin-bottom: 16px;
}

.quick-link-card {
  transition: border-color 0.2s ease;
}

.quick-link-card-wrap:hover .quick-link-card {
  border-color: #409eff;
}

.quick-link-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}

.quick-link-desc {
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}
</style>
